import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {orgReposListAppBuilder} from './config/app-builder'

import {orgReposPageRoute} from './routes/org-repos-page-route'
import {OrgReposPageForDataRouter} from '@github-ui/repos-list'

export const orgReposListApp = orgReposListAppBuilder.createDataRouterAppFromRoutes([
  orgReposPageRoute.toRoute({Component: OrgReposPageForDataRouter}),
])
registerDataRouterApp(orgReposListApp)
